import React from 'react';
import { COSYND_TERMS_PRIVACY_LINK } from '../constants';

const Footer = () => (
  <div className="footer">
    © {new Date().getFullYear()} Cosynd, Inc. All Rights Reserved. Cosynd
    provides information and self-help software at your direction only. Cosynd
    is not a "lawyer referral service," a law firm, or a substitute for an
    attorney. Cosynd does not provide legal advice, opinions, or recommendations
    about possible legal rights or participate in any legal representation. Your
    use of Cosynd is subject to our&nbsp;
    <a href={COSYND_TERMS_PRIVACY_LINK} target="_blank">
      Terms of Service
    </a>
    &nbsp;&nbsp;
    <a href={COSYND_TERMS_PRIVACY_LINK} target="_blank">
      Privacy Policy
    </a>
    .
  </div>
);

export default Footer;



// WEBPACK FOOTER //
// src/components/Footer.jsx